import {copilotSpaceIdFromThread} from '@github-ui/copilot-spaces/utils/copilot-space-id-from-thread'
import {useRef} from 'react'

import type {CustomCopilotId} from '../utils/copilot-chat-types'
import {useChatStateLens} from '../utils/CopilotChatContext'
import {customCopilotIdsAreEqual, useRouteSpaceId} from '../utils/custom-copilots-helpers'
import {getSelectedThread} from '../utils/get-selected-thread'

/**
 * Pulls the selected custom copilot (space) from either the URL or the selected thread per the chat state.
 */
export function useSelectedCustomCopilotId(): CustomCopilotId | null {
  // state.thread changes more frequently than the custom copilot ID, so we do some work to try to memoize the value
  const previousValue = useRef<CustomCopilotId | null>(null)
  const customCopilotId = useChatStateLens(state => {
    const thread = getSelectedThread(state)
    const id = copilotSpaceIdFromThread(thread)
    // because copilotSpaceIdFromThread returns a new object each time, we have to do additional work to make sure the lens doesn't trigger unnecessarily
    if (customCopilotIdsAreEqual(previousValue.current, id)) {
      return previousValue.current
    } else {
      previousValue.current = id
      return id
    }
  })
  return useRouteSpaceId() || customCopilotId
}
